import { Api } from "api";

export const getTemplates = async (nameQuery?: string) => {
  const hash = localStorage.getItem("hash");
  const name = nameQuery !== undefined ? `&name=${nameQuery}` : "";
  const res = await Api.get(`/get_templates/?hash_pw=${hash}${name}`);
  return res.data;
};

export const getTemplatesByLocation = async (type: string, location_id: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_templates_by_location/?hash_pw=${hash}&type=${type}&location_id=${location_id}`);
  return res.data;
};

export const addTemplate = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/add_template/?hash_pw=${hash}`, payload);
  return res.data;
};

export const deleteTemplate = async (templateId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.delete(`/delete_template/?hash_pw=${hash}&template_id=${templateId}`);
  return res.data;
};
